var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top"},[_vm._v(" "+_vm._s(_vm.title)+" "),_c('div',{staticClass:"actions"},[(_vm.showTip)?_c('span',{staticClass:"tip"},[_vm._v("您的浏览器设置阻止了消息的声音提示. 您可通过系统推送进行提醒, "),_c('a',{staticClass:"link",attrs:{"href":"#"}},[_vm._v(" 点击 ")]),_vm._v("查看如何设置.如若您开启了系统推送,请忽略.")]):_vm._e(),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }